import { useUILayerStore } from '@_shared/stores/useUILayerStore';

import { ContentCreateQuitPopup } from '../../ui';

export function useContentCreateQuitPopup() {
	const { pushLayer } = useUILayerStore();

	function openContentCreateQuitPopup() {
		pushLayer('popup', <ContentCreateQuitPopup />);
	}

	return {
		openContentCreateQuitPopup,
	};
}
